import { ChallengeResult, closeChallengeDialog } from '../../modules/challenge';
import { IStoreState, ThunkDispatch } from '../../modules';
import React, { Component, Fragment } from 'react';
import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core/styles';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { getCredentials, getEnrolledCredentialsForUser } from '../../modules/authmethods';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import List from '@material-ui/core/List';
import OobBioAuthButton from './auth-buttons/OobBioAuthButton';
import OobPhoneAuthButton from './auth-buttons/OobPhoneAuthButton';
import OobSmsAuthButton from './auth-buttons/OobSmsAuthButton';
import { OrderedMap } from 'immutable';
import QuestionsAuthButton from './auth-buttons/QuestionsAuthButton';
import TrxSignAuthButton from './auth-buttons/TrxSignAuthButton';
import { Typography } from '@material-ui/core';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import { connect } from 'react-redux';
import PushOtpAuthButton from './auth-buttons/PushOtpAuthButton';

const styles = (theme: Theme) => createStyles({
  authList: {
    maxWidth: theme.spacing(50),
    margin: `0 auto`,
  },
  resultPane: {
    display: 'flex',
    textAlign: 'center',
    margin: `${theme.spacing(3)}px 0 ${theme.spacing(5)}px`,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  resultIcon: {
    marginRight: theme.spacing(2)
  },
  resultIconGreen: {
    color: 'green',
  },
  resultIconRed: {
    color: 'red',
  },
  dialogActions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  hidden: {
    opacity: 0.1,
    '&:hover': {
      opacity: 1,
    }
  }
})

type State = {
  error: Error | null
  loading: boolean
  challengeRequestElement: JSX.Element | null
  complete: boolean
  result: ChallengeResult
};

class ChallengeDialog extends Component<Props, State> {
  static credentials = OrderedMap<string, any>().withMutations(map => {
    map
      .set("QUESTION", QuestionsAuthButton)
      .set("OOBPHONE", OobPhoneAuthButton)
      .set("OOBSMS", OobSmsAuthButton)
      .set("OOBBIOMETRICS", OobBioAuthButton)
      .set("OTPMOBILEAPP" , PushOtpAuthButton)
      .set("TRXSIGN", TrxSignAuthButton)
  })

  state: State = {
    error: null,
    loading: true,
    challengeRequestElement: null,
    complete: false,
    result: ChallengeResult.Pending,
  }
  componentDidMount() {
    try {
      this.props.getCredentials()
        .then((response: any) => {
          this.setState({ loading: false })
        })
    } catch (error) {
      console.error(error)
      this.setState({ error: error.message })
    }
  }

  handleCancel = () => {
    this.props.closeChallengeDialog(ChallengeResult.Failure)
  }

  handleAuthenticate() {
    this.props.closeChallengeDialog(ChallengeResult.Success)
  }

  setChallengeRequestComponent = (challengeRequestElement: JSX.Element | null) => {
    this.setState({ challengeRequestElement })
  }

  handleChallengeResponse = (result: ChallengeResult) => {
    if (result === ChallengeResult.Pending)
      this.setChallengeRequestComponent(null)
    else {
      this.setState({ complete: true, result })
      setTimeout(() => this.props.closeChallengeDialog(result), 1000)
    }
  }

  render() {
    const { challenge, classes } = this.props;
    const { loading, challengeRequestElement, complete, result } = this.state;

    let credentials = ChallengeDialog.credentials.asMutable()

    return (
      <Dialog
        open={challenge.open}
        aria-labelledby="form-dialog-title"
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="form-dialog-title">Step-Up Authentication Required</DialogTitle>
        {!challengeRequestElement && !complete &&
          <Fragment>
            <DialogContent>
              <DialogContentText>
                You are attempting to perform a high-risk transaction. Please verify your identity to proceed.
            </DialogContentText>
              <List className={classes.authList}>
                {
                  // show the list of required credentials first, in order of preference
                  _.castArray(_.get(challenge, "analyzeResponse.requiredCredentialList.requiredCredential", [])).map(c => {
                    let type = (c.credentialType === "USER_DEFINED" ? c.genericCredentialType : c.credentialType) as string
                    let AuthButton = credentials.get(type, null)

                    if (AuthButton !== null) {
                      credentials.delete(type)
                      return <AuthButton
                        loading={loading}
                        setChallengeRequestComponent={this.setChallengeRequestComponent}
                        challengeResponse={this.handleChallengeResponse} />
                    }
                    return ""
                  })
                }
                {
                  _.castArray(_.get(challenge, "analyzeResponse.requiredCredentialList.requiredCredential", [])).length === 0 &&
                  <Typography variant="body2">You do not have any of the required credentials.</Typography>
                }
                {/*
                  // and then the other credentials that are not required
                  credentials.toList().map((AuthButton, i) => {
                    return <AuthButton
                      key={i}
                      loading={loading}
                      setChallengeRequestComponent={this.setChallengeRequestComponent}
                      challengeResponse={this.handleChallengeResponse} />
                  })
                */}
              </List>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              <Button onClick={this.handleCancel} color="default">
                Cancel
            </Button>
              <Button onClick={this.handleAuthenticate.bind(this)} color="primary" className={classes.hidden}>
                Skip
            </Button>
            </DialogActions>
          </Fragment>
        }
        {challengeRequestElement && !complete &&
          <Fragment>
            {challengeRequestElement}
          </Fragment>
        }
        {complete &&
          <div className={classes.resultPane}>
            <FontAwesomeIcon
              size="2x"
              icon={result === ChallengeResult.Success ? faCheck : faTimes}
              className={classNames(classes.resultIcon, (result === ChallengeResult.Success ? classes.resultIconGreen : classes.resultIconRed))} />
            <Typography variant="h5">
              {result === ChallengeResult.Success && 'Challenge Success'}
              {result === ChallengeResult.Failure && 'Challenge Failed'}
            </Typography>
          </div>
        }

      </Dialog>
    )
  }
}


const mapStateToProps = ({ auth, authmethods, challenge, intl }: IStoreState) => ({
  auth,
  authmethods,
  challenge,
  intl
})

const mapDispatchToProps = (dispatch: ThunkDispatch) =>
  bindActionCreators(
    {
      closeChallengeDialog,
      getEnrolledCredentialsForUser,
      getCredentials
    }, dispatch
  )

interface Props extends WithStyles<typeof styles>, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps> {
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ChallengeDialog));